export enum SectionColumnConfigState {
  On = 'On',
  Off = 'Off',
  Auto = 'Auto',
  Disabled = 'Disabled'
}
